import { reportService } from "../services/report-service";
import { generatePrintedForm } from "./common";

export const generateReport = (code, data, type, filename) => {
  return reportService.generateReport(code, data).then(({ data }) => {
    generatePrintedForm(data, filename, type)
  })
}

